import styled from "styled-components";

export const StyledBtn = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  background-color: transparent;
`;
